import createReactComponent from '../createReactComponent';
export default createReactComponent('heading', 'Heading', [["path",{"d":"M7.25 4.5v15m9.5-15v15M7.25 12h9.5","key":"svg-0"}]]);